
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/rich-text.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-rich-text-demo-codehighlighter"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/rich-text.en-US.md?type=demo')
};